import { Typography } from '@interstate/components/Typography';
import { AddressContent, CardContainer } from './CustomerAddresses.styles';
import { AddressCardHeader } from './AddressCardHeader';
import { useCustomerAddress } from './CustomerAddressProvider';
import type { AddressType } from './CustomerAddressTypes';
import { getFormattedAddress } from './CustomerAddressUtils';

type CustomerAddressCardProps = {
    type: AddressType;
};

export const CustomerAddressCard = ({ type }: CustomerAddressCardProps) => {
    const { getAddressByType } = useCustomerAddress();
    const { data: addressData } = getAddressByType(type);
    const formattedAddress = getFormattedAddress(addressData);

    return (
        <CardContainer header={<AddressCardHeader type={type} />}>
            <AddressContent>
                {formattedAddress.map((line, index) => (
                    <Typography data-testid="address-line" variant="body-sm" key={index} className="pii">
                        {line}
                    </Typography>
                ))}
            </AddressContent>
        </CardContainer>
    );
};
